import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import React, {useState} from 'react';
import text from './text';
import close from './icons/close.svg';

const language = window.location.hash === '#en' ? 'eng' : 'hun';


const PRESETS = [
  { name: 'autópályák + M0', text: 'M0 M1 M3 M5 M6 M7'},
  { name: 'főbb utak', text: '1 2 3 4 5 6 7 8'},
]

export default ({onChange, value}) => {
  const newText = (v) => {
	onChange(v)
  }  


  return (
    <div className="filterByText option">   
      <table>
	    <tbody>
		    <tr>
			    <td  id='hideThis'>
            <TextField
              	style={{width: 280}}
				label={text[language].searchbox.settlement}
				className="filterByTextInput"
				variant="filled"
				value={value}
				//onChange={e => onClick(e.target.value)}
				onChange={e => newText(e.target.value)}
				margin="normal"
				// variant="outlined"
				color="primary"
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
						<IconButton
							edge="end"
							aria-label="clear text filter"
							onClick={e => newText('')}
						>
							 <img src={close} className="filter-clear-button" alt={text[language].searchbox.allButtonText} title={text[language].searchbox.clerText} />
						</IconButton>
						</InputAdornment>
					),
					}}
            />
			
          </td>
		  </tr>
	    </tbody>
      </table>
    </div>
  );
}